import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import { en } from "./translations/en";
import { fr } from "./translations/fr";

const translations = { en, fr } as const;

export const useTranslation = () => {
  const { locale, setLocale } = useContext(LanguageContext);
  const dict = translations[locale];

  const t = (key: string): string => {
    const keys = key.split(".");
    let result: any = dict;
    for (const k of keys) {
      result = result?.[k];
    }
    return typeof result === "string" ? result : key;
  };

  return { t, locale, setLocale };
};
